import styled from "styled-components";
import {FadeWrapper} from "../../../fade-in-div-on-mount.component";

interface IOnboardingDialogBoxProps {
    zIndex: number;
}

export const OnboardingDialogDefaultBox = styled(FadeWrapper)<IOnboardingDialogBoxProps>`
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16);
    position: fixed;
    z-index: ${({zIndex}) => zIndex};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
    width: 47rem;
    max-width: calc(100% - 3rem);
    padding: 7.8rem 2rem 2rem 2rem;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    color: ${({theme}) => theme.colors.textLight};
    border-radius: 4px;
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        top: unset;
        transform: translate(-50%);
        bottom: 1.5rem;
        padding: 6.1rem 1.5rem 1.5rem 1.5rem;
    }
`;